import { makeStyles } from "@fluentui/react-components";

export const useScrollableContainerStyles = makeStyles({
  scrollContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    flex: 1,
    minHeight: 0,
    overflowY: "overlay",

    "&:hover": {
      overflowY: "auto",

      "&::-webkit-scrollbar": {
        width: "8px",
        height: "8px",
      },

      "&::-webkit-scrollbar-track": {
        backgroundColor: "var(--track-bg)",
        borderRadius: "4px",
      },

      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "var(--thumb-bg)",
        borderRadius: "4px",
        border: "2px solid var(--track-bg)",

        "&:hover": {
          backgroundColor: "var(--thumb-hover)",
        },

        "&:active": {
          backgroundColor: "var(--thumb-active)",
        },
      },
    },

    // Firefox
    scrollbarWidth: "thin",
    scrollbarColor: "var(--thumb-bg) var(--track-bg)",
  },
});
